function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t5, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t5, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n2 = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n2 >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n2++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { isObject as Ut } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isObject.js";
import { isString as ot } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isString.js";
import { isFunction as st } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/predicate/isFunction.js";
import { isElement as xt } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isElement.js";
import { isPlainObject as k } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isPlainObject.js";
import { cloneDeepWith as $t } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/cloneDeepWith.js";
import { merge as Gt } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/merge.js"; /**
                                                                                                                    * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                    * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                    */ /**
                                                                                                                       * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                       * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                       */
var $;
try {
  $ = {
    window: window,
    document: document
  };
} catch (_unused) {
  /* istanbul ignore next -- @preserve */$ = {
    window: {},
    document: {}
  };
}
var w = $;
function qt() {
  try {
    return navigator.userAgent.toLowerCase();
  } catch (_unused2) {
    return "";
  }
}
var x = qt(),
  A = {
    isMac: It(x),
    isWindows: Yt(x),
    isGecko: Xt(x),
    isSafari: Jt(x),
    isiOS: Qt(x),
    isAndroid: Zt(x),
    isBlink: zt(x),
    get isMediaForcedColors() {
      return te();
    }
  };
function It(e) {
  return e.indexOf("macintosh") > -1;
}
function Yt(e) {
  return e.indexOf("windows") > -1;
}
function Xt(e) {
  return !!e.match(/gecko\/\d+/);
}
function Jt(e) {
  return e.indexOf(" applewebkit/") > -1 && e.indexOf("chrome") === -1;
}
function Qt(e) {
  return !!e.match(/iphone|ipad/i) || It(e) && navigator.maxTouchPoints > 0;
}
function Zt(e) {
  return e.indexOf("android") > -1;
}
function zt(e) {
  return e.indexOf("chrome/") > -1 && e.indexOf("edge/") < 0;
}
function te() {
  return w.window.matchMedia ? w.window.matchMedia("(forced-colors: active)").matches : !1;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function ee(e, t, n, i) {
  n = n || function (c, a) {
    return c === a;
  };
  var o = Array.isArray(e) ? e : Array.prototype.slice.call(e),
    s = Array.isArray(t) ? t : Array.prototype.slice.call(t),
    r = ne(o, s, n);
  return i ? oe(r, s.length) : ie(s, r);
}
function ne(e, t, n) {
  var i = rt(e, t, n);
  if (i === -1) return {
    firstIndex: -1,
    lastIndexOld: -1,
    lastIndexNew: -1
  };
  var o = lt(e, i),
    s = lt(t, i),
    r = rt(o, s, n),
    l = e.length - r,
    c = t.length - r;
  return {
    firstIndex: i,
    lastIndexOld: l,
    lastIndexNew: c
  };
}
function rt(e, t, n) {
  for (var i = 0; i < Math.max(e.length, t.length); i++) if (e[i] === void 0 || t[i] === void 0 || !n(e[i], t[i])) return i;
  return -1;
}
function lt(e, t) {
  return e.slice(t).reverse();
}
function ie(e, t) {
  var n = [],
    i = t.firstIndex,
    o = t.lastIndexOld,
    s = t.lastIndexNew;
  return s - i > 0 && n.push({
    index: i,
    type: "insert",
    values: e.slice(i, s)
  }), o - i > 0 && n.push({
    index: i + (s - i),
    type: "delete",
    howMany: o - i
  }), n;
}
function oe(e, t) {
  var n = e.firstIndex,
    i = e.lastIndexOld,
    o = e.lastIndexNew;
  if (n === -1) return Array(t).fill("equal");
  var s = [];
  return n > 0 && (s = s.concat(Array(n).fill("equal"))), o - n > 0 && (s = s.concat(Array(o - n).fill("insert"))), i - n > 0 && (s = s.concat(Array(i - n).fill("delete"))), o < t && (s = s.concat(Array(t - o).fill("equal"))), s;
}
function Lt(e, t, n) {
  n = n || function (p, F) {
    return p === F;
  };
  var i = e.length,
    o = t.length;
  if (i > 200 || o > 200 || i + o > 300) return Lt.fastDiff(e, t, n, !0);
  var s, r;
  if (o < i) {
    var p = e;
    e = t, t = p, s = "delete", r = "insert";
  } else s = "insert", r = "delete";
  var l = e.length,
    c = t.length,
    a = c - l,
    f = {},
    u = {};
  function _(p) {
    var F = (u[p - 1] !== void 0 ? u[p - 1] : -1) + 1,
      j = u[p + 1] !== void 0 ? u[p + 1] : -1,
      it = F > j ? -1 : 1;
    f[p + it] && (f[p] = f[p + it].slice(0)), f[p] || (f[p] = []), f[p].push(F > j ? s : r);
    var M = Math.max(F, j),
      O = M - p;
    for (; O < l && M < c && n(e[O], t[M]);) O++, M++, f[p].push("equal");
    return M;
  }
  var C = 0,
    y;
  do {
    for (y = -C; y < a; y++) u[y] = _(y);
    for (y = a + C; y > a; y--) u[y] = _(y);
    u[a] = _(a), C++;
  } while (u[a] !== c);
  return f[a].slice(1);
}
Lt.fastDiff = ee; /**
                  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                  */
function ct() {
  return function e() {
    e.called = !0;
  };
}
var G = /*#__PURE__*/_createClass(function G(t, n) {
  _classCallCheck(this, G);
  _defineProperty(this, "source", void 0);
  _defineProperty(this, "name", void 0);
  _defineProperty(this, "path", void 0);
  _defineProperty(this, "stop", void 0);
  _defineProperty(this, "off", void 0);
  _defineProperty(this, "return", void 0);
  this.source = t, this.name = n, this.path = [], this.stop = ct(), this.off = ct();
});
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
var b = new Array(256).fill("").map(function (e, t) {
  return ("0" + t.toString(16)).slice(-2);
});
function Q() {
  var _crypto$getRandomValu = crypto.getRandomValues(new Uint32Array(4)),
    _crypto$getRandomValu2 = _slicedToArray(_crypto$getRandomValu, 4),
    e = _crypto$getRandomValu2[0],
    t = _crypto$getRandomValu2[1],
    n = _crypto$getRandomValu2[2],
    i = _crypto$getRandomValu2[3];
  return "e" + b[e >> 0 & 255] + b[e >> 8 & 255] + b[e >> 16 & 255] + b[e >> 24 & 255] + b[t >> 0 & 255] + b[t >> 8 & 255] + b[t >> 16 & 255] + b[t >> 24 & 255] + b[n >> 0 & 255] + b[n >> 8 & 255] + b[n >> 16 & 255] + b[n >> 24 & 255] + b[i >> 0 & 255] + b[i >> 8 & 255] + b[i >> 16 & 255] + b[i >> 24 & 255];
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
var q = {
  get: function get() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "normal";
    return typeof e != "number" ? this[e] || this.normal : e;
  },
  highest: 1e5,
  high: 1e3,
  normal: 0,
  low: -1e3,
  lowest: -1e5
};
function se(e, t) {
  var n = q.get(t.priority);
  var i = 0,
    o = e.length;
  for (; i < o;) {
    var s = i + o >> 1;
    q.get(e[s].priority) < n ? o = s : i = s + 1;
  }
  e.splice(i, 0, t);
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
var re = "https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html";
var d = /*#__PURE__*/function (_Error) {
  function d(t, n, i) {
    var _this;
    _classCallCheck(this, d);
    _this = _callSuper(this, d, [le(t, i)]), _defineProperty(_assertThisInitialized(_this), "context", void 0), _defineProperty(_assertThisInitialized(_this), "data", void 0), _this.name = "CKEditorError", _this.context = n, _this.data = i;
    return _this;
  }
  _inherits(d, _Error);
  return _createClass(d, [{
    key: "is",
    value: function is(t) {
      return t === "CKEditorError";
    }
  }], [{
    key: "rethrowUnexpectedError",
    value: function rethrowUnexpectedError(t, n) {
      if (t.is && t.is("CKEditorError")) throw t;
      var i = new d(t.message, n);
      throw i.stack = t.stack, i;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Error));
function dn(e, t) {
  var _console;
  (_console = console).warn.apply(_console, _toConsumableArray(Ct(e, t)));
}
function hn(e, t) {
  var _console2;
  (_console2 = console).error.apply(_console2, _toConsumableArray(Ct(e, t)));
}
function At(e) {
  return "\nRead more: ".concat(re, "#error-").concat(e);
}
function le(e, t) {
  var n = new WeakSet(),
    o = t ? " ".concat(JSON.stringify(t, function (r, l) {
      if (_typeof(l) == "object" && l !== null) {
        if (n.has(l)) return "[object ".concat(l.constructor.name, "]");
        n.add(l);
      }
      return l;
    })) : "",
    s = At(e);
  return e + o + s;
}
function Ct(e, t) {
  var n = At(e);
  return t ? [e, t, n] : [e, n];
}
var ce = "45.2.1",
  pn = new Date(2025, 5, 24); /* istanbul ignore next -- @preserve */
if (globalThis.CKEDITOR_VERSION) throw new d("ckeditor-duplicated-modules", null);
globalThis.CKEDITOR_VERSION = ce;
var L = Symbol("listeningTo"),
  Y = Symbol("emitterId"),
  E = Symbol("delegations"),
  Ft = T(Object);
function T(e) {
  if (!e) return Ft;
  var t = /*#__PURE__*/function (_e2) {
    function t() {
      _classCallCheck(this, t);
      return _callSuper(this, t, arguments);
    }
    _inherits(t, _e2);
    return _createClass(t, [{
      key: "on",
      value: function on(i, o, s) {
        this.listenTo(this, i, o, s);
      }
    }, {
      key: "once",
      value: function once(i, o, s) {
        var _this2 = this;
        var r = !1;
        var l = function l(c) {
          for (var _len = arguments.length, a = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            a[_key - 1] = arguments[_key];
          }
          r || (r = !0, c.off(), o.call.apply(o, [_this2, c].concat(a)));
        };
        this.listenTo(this, i, l, s);
      }
    }, {
      key: "off",
      value: function off(i, o) {
        this.stopListening(this, i, o);
      }
    }, {
      key: "listenTo",
      value: function listenTo(i, o, s) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var l, c;
        this[L] || (this[L] = {});
        var a = this[L];
        W(i) || Mt(i);
        var f = W(i);
        (l = a[f]) || (l = a[f] = {
          emitter: i,
          callbacks: {}
        }), (c = l.callbacks[o]) || (c = l.callbacks[o] = []), c.push(s), he(this, i, o, s, r);
      }
    }, {
      key: "stopListening",
      value: function stopListening(i, o, s) {
        var r = this[L];
        var l = i && W(i);
        var c = r && l ? r[l] : void 0,
          a = c && o ? c.callbacks[o] : void 0;
        if (!(!r || i && !c || o && !a)) if (s) K(this, i, o, s), a.indexOf(s) !== -1 && (a.length === 1 ? delete c.callbacks[o] : K(this, i, o, s));else if (a) {
          for (; s = a.pop();) K(this, i, o, s);
          delete c.callbacks[o];
        } else if (c) {
          for (o in c.callbacks) this.stopListening(i, o);
          delete r[l];
        } else {
          for (l in r) this.stopListening(r[l].emitter);
          delete this[L];
        }
      }
    }, {
      key: "fire",
      value: function fire(i) {
        try {
          var s = i instanceof G ? i : new G(this, i),
            r = s.name;
          var l = de(this, r);
          for (var _len2 = arguments.length, o = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            o[_key2 - 1] = arguments[_key2];
          }
          if (s.path.push(this), l) {
            l = l.slice();
            for (var a = 0; a < l.length; a++) {
              var f = l[a].callback;
              if (f.call.apply(f, [this, s].concat(o)), s.off.called && (delete s.off.called, this._removeEventListener(r, f)), s.stop.called) break;
            }
          }
          var c = this[E];
          if (c) {
            var _a = c.get(r),
              _f = c.get("*");
            _a && at(_a, s, o), _f && at(_f, s, o);
          }
          return s.return;
        } catch (s) {
          /* istanbul ignore next -- @preserve */d.rethrowUnexpectedError(s, this);
        }
      }
    }, {
      key: "delegate",
      value: function delegate() {
        var _this3 = this;
        for (var _len3 = arguments.length, i = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          i[_key3] = arguments[_key3];
        }
        return {
          to: function to(o, s) {
            _this3[E] || (_this3[E] = new Map()), i.forEach(function (r) {
              var l = _this3[E].get(r);
              l ? l.set(o, s) : _this3[E].set(r, new Map([[o, s]]));
            });
          }
        };
      }
    }, {
      key: "stopDelegating",
      value: function stopDelegating(i, o) {
        if (this[E]) if (!i) this[E].clear();else if (!o) this[E].delete(i);else {
          var s = this[E].get(i);
          s && s.delete(o);
        }
      }
    }, {
      key: "_addEventListener",
      value: function _addEventListener(i, o, s) {
        ue(this, i);
        var r = X(this, i),
          l = q.get(s.priority),
          c = {
            callback: o,
            priority: l
          };
        var _iterator = _createForOfIteratorHelper(r),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var a = _step.value;
            se(a, c);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "_removeEventListener",
      value: function _removeEventListener(i, o) {
        var s = X(this, i);
        var _iterator2 = _createForOfIteratorHelper(s),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var r = _step2.value;
            for (var l = 0; l < r.length; l++) r[l].callback == o && (r.splice(l, 1), l--);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }]);
  }(e);
  return t;
}
["on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(function (e) {
  T[e] = Ft.prototype[e];
});
function ae(e, t) {
  var n = e[L];
  return n && n[t] ? n[t].emitter : null;
}
function Mt(e, t) {
  e[Y] || (e[Y] = t || Q());
}
function W(e) {
  return e[Y];
}
function kt(e) {
  return e._events || Object.defineProperty(e, "_events", {
    value: {}
  }), e._events;
}
function fe() {
  return {
    callbacks: [],
    childEvents: []
  };
}
function ue(e, t) {
  var n = kt(e);
  if (n[t]) return;
  var i = t,
    o = null;
  var s = [];
  for (; i !== "" && !n[i];) n[i] = fe(), s.push(n[i]), o && n[i].childEvents.push(o), o = i, i = i.substr(0, i.lastIndexOf(":"));
  if (i !== "") {
    var _iterator3 = _createForOfIteratorHelper(s),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var r = _step3.value;
        r.callbacks = n[i].callbacks.slice();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    n[i].childEvents.push(o);
  }
}
function X(e, t) {
  var n = kt(e)[t];
  if (!n) return [];
  var i = [n.callbacks];
  for (var o = 0; o < n.childEvents.length; o++) {
    var s = X(e, n.childEvents[o]);
    i = i.concat(s);
  }
  return i;
}
function de(e, t) {
  if (!e._events) return null;
  var n = t;
  do {
    var i = e._events[n];
    if (i && i.callbacks && i.callbacks.length) return i.callbacks;
    var o = n.lastIndexOf(":");
    n = o > -1 ? n.substring(0, o) : "";
  } while (n);
  return null;
}
function at(e, t, n) {
  var _iterator4 = _createForOfIteratorHelper(e),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _ref = _step4.value;
      var _ref2 = _slicedToArray(_ref, 2);
      var i = _ref2[0];
      var o = _ref2[1];
      o ? typeof o == "function" && (o = o(t.name)) : o = t.name;
      var s = new G(t.source, o);
      s.path = _toConsumableArray(t.path), i.fire.apply(i, [s].concat(_toConsumableArray(n)));
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}
function he(e, t, n, i, o) {
  t._addEventListener ? t._addEventListener(n, i, o) : e._addEventListener.call(t, n, i, o);
}
function K(e, t, n, i) {
  t._removeEventListener ? t._removeEventListener(n, i) : e._removeEventListener.call(t, n, i);
}
var v = Symbol("observableProperties"),
  V = Symbol("boundObservables"),
  S = Symbol("boundProperties"),
  I = Symbol("decoratedMethods"),
  ft = Symbol("decoratedOriginal"),
  vt = Z(T());
function Z(e) {
  if (!e) return vt;
  var t = /*#__PURE__*/function (_e3) {
    function t() {
      var _this4;
      _classCallCheck(this, t);
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      _this4 = _callSuper(this, t, [].concat(args));
      _defineProperty(_this4, v, void 0);
      _defineProperty(_this4, I, void 0);
      _defineProperty(_this4, S, void 0);
      _defineProperty(_this4, V, void 0);
      return _this4;
    }
    _inherits(t, _e3);
    return _createClass(t, [{
      key: "set",
      value: function set(i, o) {
        var _this5 = this;
        if (Ut(i)) {
          Object.keys(i).forEach(function (r) {
            _this5.set(r, i[r]);
          }, this);
          return;
        }
        H(this);
        var s = this[v];
        if (i in this && !s.has(i)) throw new d("observable-set-cannot-override", this);
        Object.defineProperty(this, i, {
          enumerable: !0,
          configurable: !0,
          get: function get() {
            return s.get(i);
          },
          set: function set(r) {
            var l = s.get(i);
            var c = this.fire("set:".concat(i), i, r, l);
            c === void 0 && (c = r), (l !== c || !s.has(i)) && (s.set(i, c), this.fire("change:".concat(i), i, c, l));
          }
        }), this[i] = o;
      }
    }, {
      key: "bind",
      value: function bind() {
        var _this6 = this;
        for (var _len5 = arguments.length, i = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          i[_key5] = arguments[_key5];
        }
        if (!i.length || !ut(i)) throw new d("observable-bind-wrong-properties", this);
        if (new Set(i).size !== i.length) throw new d("observable-bind-duplicate-properties", this);
        H(this);
        var o = this[S];
        i.forEach(function (r) {
          if (o.has(r)) throw new d("observable-bind-rebind", _this6);
        });
        var s = new Map();
        return i.forEach(function (r) {
          var l = {
            property: r,
            to: []
          };
          o.set(r, l), s.set(r, l);
        }), {
          to: pe,
          toMany: ge,
          _observable: this,
          _bindProperties: i,
          _to: [],
          _bindings: s
        };
      }
    }, {
      key: "unbind",
      value: function unbind() {
        var _this7 = this;
        if (!this[v]) return;
        var o = this[S],
          s = this[V];
        for (var _len6 = arguments.length, i = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          i[_key6] = arguments[_key6];
        }
        if (i.length) {
          if (!ut(i)) throw new d("observable-unbind-wrong-properties", this);
          i.forEach(function (r) {
            var l = o.get(r);
            l && (l.to.forEach(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                c = _ref4[0],
                a = _ref4[1];
              var f = s.get(c),
                u = f[a];
              u.delete(l), u.size || delete f[a], Object.keys(f).length || (s.delete(c), _this7.stopListening(c, "change"));
            }), o.delete(r));
          });
        } else s.forEach(function (r, l) {
          _this7.stopListening(l, "change");
        }), s.clear(), o.clear();
      }
    }, {
      key: "decorate",
      value: function decorate(i) {
        var _this8 = this;
        H(this);
        var o = this[i];
        if (!o) throw new d("observablemixin-cannot-decorate-undefined", this, {
          object: this,
          methodName: i
        });
        this.on(i, function (s, r) {
          s.return = o.apply(_this8, r);
        }), this[i] = function () {
          for (var _len7 = arguments.length, s = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            s[_key7] = arguments[_key7];
          }
          return this.fire(i, s);
        }, this[i][ft] = o, this[I] || (this[I] = []), this[I].push(i);
      }
    }, {
      key: "stopListening",
      value: function stopListening(i, o, s) {
        if (!i && this[I]) {
          var _iterator5 = _createForOfIteratorHelper(this[I]),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var r = _step5.value;
              this[r] = this[r][ft];
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          delete this[I];
        }
        _superPropGet(t, "stopListening", this, 3)([i, o, s]);
      }
    }]);
  }(e);
  return t;
}
["set", "bind", "unbind", "decorate", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(function (e) {
  Z[e] = vt.prototype[e];
});
function H(e) {
  e[v] || (Object.defineProperty(e, v, {
    value: new Map()
  }), Object.defineProperty(e, V, {
    value: new Map()
  }), Object.defineProperty(e, S, {
    value: new Map()
  }));
}
function pe() {
  var _this9 = this;
  var t = be.apply(void 0, arguments),
    n = Array.from(this._bindings.keys()),
    i = n.length;
  if (!t.callback && t.to.length > 1) throw new d("observable-bind-to-no-callback", this);
  if (i > 1 && t.callback) throw new d("observable-bind-to-extra-callback", this);
  t.to.forEach(function (o) {
    if (o.properties.length && o.properties.length !== i) throw new d("observable-bind-to-properties-length", _this9);
    o.properties.length || (o.properties = _this9._bindProperties);
  }), this._to = t.to, t.callback && (this._bindings.get(n[0]).callback = t.callback), ye(this._observable, this._to), we(this), this._bindProperties.forEach(function (o) {
    St(_this9._observable, o);
  });
}
function ge(e, t, n) {
  if (this._bindings.size > 1) throw new d("observable-bind-to-many-not-one-binding", this);
  this.to.apply(this, _toConsumableArray(me(e, t)).concat([n]));
}
function me(e, t) {
  var n = e.map(function (i) {
    return [i, t];
  });
  return Array.prototype.concat.apply([], n);
}
function ut(e) {
  return e.every(function (t) {
    return typeof t == "string";
  });
}
function be() {
  for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    e[_key8] = arguments[_key8];
  }
  if (!e.length) throw new d("observable-bind-to-parse-error", null);
  var t = {
    to: []
  };
  var n;
  return typeof e[e.length - 1] == "function" && (t.callback = e.pop()), e.forEach(function (i) {
    if (typeof i == "string") n.properties.push(i);else if (_typeof(i) == "object") n = {
      observable: i,
      properties: []
    }, t.to.push(n);else throw new d("observable-bind-to-parse-error", null);
  }), t;
}
function _e(e, t, n, i) {
  var o = e[V],
    s = o.get(n),
    r = s || {};
  r[i] || (r[i] = new Set()), r[i].add(t), s || o.set(n, r);
}
function we(e) {
  var t;
  e._bindings.forEach(function (n, i) {
    e._to.forEach(function (o) {
      t = o.properties[n.callback ? 0 : e._bindProperties.indexOf(i)], n.to.push([o.observable, t]), _e(e._observable, n, o.observable, t);
    });
  });
}
function St(e, t) {
  var i = e[S].get(t);
  var o;
  i.callback ? o = i.callback.apply(e, i.to.map(function (s) {
    return s[0][s[1]];
  })) : (o = i.to[0], o = o[0][o[1]]), Object.prototype.hasOwnProperty.call(e, t) ? e[t] = o : e.set(t, o);
}
function ye(e, t) {
  t.forEach(function (n) {
    var i = e[V];
    var o;
    i.get(n.observable) || e.listenTo(n.observable, "change", function (s, r) {
      o = i.get(n.observable)[r], o && o.forEach(function (l) {
        St(e, l.property);
      });
    });
  });
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
var gn = /*#__PURE__*/function () {
  function gn() {
    _classCallCheck(this, gn);
    _defineProperty(this, "_replacedElements", void 0);
    this._replacedElements = [];
  }
  return _createClass(gn, [{
    key: "replace",
    value: function replace(t, n) {
      this._replacedElements.push({
        element: t,
        newElement: n
      }), t.style.display = "none", n && t.parentNode.insertBefore(n, t.nextSibling);
    }
  }, {
    key: "restore",
    value: function restore() {
      this._replacedElements.forEach(function (_ref5) {
        var t = _ref5.element,
          n = _ref5.newElement;
        t.style.display = "", n && n.remove();
      }), this._replacedElements = [];
    }
  }]);
}();
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function mn(e) {
  var t = 0;
  var _iterator6 = _createForOfIteratorHelper(e),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var n = _step6.value;
      t++;
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return t;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function bn(e, t) {
  var n = Math.min(e.length, t.length);
  for (var i = 0; i < n; i++) if (e[i] != t[i]) return i;
  return e.length == t.length ? "same" : e.length < t.length ? "prefix" : "extension";
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function z(e) {
  return !!(e && e[Symbol.iterator]);
}
function _n(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var o = n && n.xmlns,
    s = o ? e.createElementNS(o, t) : e.createElement(t);
  for (var r in n) s.setAttribute(r, n[r]);
  (ot(i) || !z(i)) && (i = [i]);
  var _iterator7 = _createForOfIteratorHelper(i),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _r = _step7.value;
      ot(_r) && (_r = e.createTextNode(_r)), s.appendChild(_r);
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  return s;
}
var wn = /*#__PURE__*/function () {
  function wn(t, n) {
    _classCallCheck(this, wn);
    _defineProperty(this, "_config", void 0);
    this._config = Object.create(null), n && this.define(dt(n)), t && this._setObjectToTarget(this._config, t);
  }
  return _createClass(wn, [{
    key: "set",
    value: function set(t, n) {
      this._setToTarget(this._config, t, n);
    }
  }, {
    key: "define",
    value: function define(t, n) {
      this._setToTarget(this._config, t, n, !0);
    }
  }, {
    key: "get",
    value: function get(t) {
      return this._getFromSource(this._config, t);
    }
  }, {
    key: "names",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
      var _i, _Object$keys, t;
      return _regeneratorRuntime().wrap(function names$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _i = 0, _Object$keys = Object.keys(this._config);
          case 1:
            if (!(_i < _Object$keys.length)) {
              _context.next = 8;
              break;
            }
            t = _Object$keys[_i];
            _context.next = 5;
            return t;
          case 5:
            _i++;
            _context.next = 1;
            break;
          case 8:
          case "end":
            return _context.stop();
        }
      }, names, this);
    })
  }, {
    key: "_setToTarget",
    value: function _setToTarget(t, n, i) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      if (k(n)) {
        this._setObjectToTarget(t, n, o);
        return;
      }
      var s = n.split(".");
      n = s.pop();
      var _iterator8 = _createForOfIteratorHelper(s),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var r = _step8.value;
          k(t[r]) || (t[r] = Object.create(null)), t = t[r];
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      if (k(i)) {
        k(t[n]) || (t[n] = Object.create(null)), t = t[n], this._setObjectToTarget(t, i, o);
        return;
      }
      o && _typeof(t[n]) < "u" || (t[n] = i);
    }
  }, {
    key: "_getFromSource",
    value: function _getFromSource(t, n) {
      var i = n.split(".");
      n = i.pop();
      var _iterator9 = _createForOfIteratorHelper(i),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var o = _step9.value;
          if (!k(t[o])) {
            t = null;
            break;
          }
          t = t[o];
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return t ? dt(t[n]) : void 0;
    }
  }, {
    key: "_setObjectToTarget",
    value: function _setObjectToTarget(t, n, i) {
      var _this0 = this;
      Object.keys(n).forEach(function (o) {
        _this0._setToTarget(t, o, n[o], i);
      });
    }
  }]);
}();
function dt(e) {
  return $t(e, Ee);
}
function Ee(e) {
  return xt(e) || typeof e == "function" ? e : void 0;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function ht(e) {
  if (e) {
    if (e.defaultView) return e instanceof e.defaultView.Document;
    if (e.ownerDocument && e.ownerDocument.defaultView) return e instanceof e.ownerDocument.defaultView.Node;
  }
  return !1;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function N(e) {
  var t = Object.prototype.toString.apply(e);
  return t == "[object Window]" || t == "[object global]";
}
var Vt = D(T());
function D(e) {
  if (!e) return Vt;
  var t = /*#__PURE__*/function (_e4) {
    function t() {
      _classCallCheck(this, t);
      return _callSuper(this, t, arguments);
    }
    _inherits(t, _e4);
    return _createClass(t, [{
      key: "listenTo",
      value: function listenTo(i, o, s) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (ht(i) || N(i) || i instanceof w.window.EventTarget) {
          var l = {
              capture: !!r.useCapture,
              passive: !!r.usePassive
            },
            c = this._getProxyEmitter(i, l) || new Te(i, l);
          this.listenTo(c, o, s, r);
        } else _superPropGet(t, "listenTo", this, 3)([i, o, s, r]);
      }
    }, {
      key: "stopListening",
      value: function stopListening(i, o, s) {
        if (ht(i) || N(i) || i instanceof w.window.EventTarget) {
          var r = this._getAllProxyEmitters(i);
          var _iterator0 = _createForOfIteratorHelper(r),
            _step0;
          try {
            for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
              var l = _step0.value;
              this.stopListening(l, o, s);
            }
          } catch (err) {
            _iterator0.e(err);
          } finally {
            _iterator0.f();
          }
        } else _superPropGet(t, "stopListening", this, 3)([i, o, s]);
      }
    }, {
      key: "_getProxyEmitter",
      value: function _getProxyEmitter(i, o) {
        return ae(this, Rt(i, o));
      }
    }, {
      key: "_getAllProxyEmitters",
      value: function _getAllProxyEmitters(i) {
        var _this1 = this;
        return [{
          capture: !1,
          passive: !1
        }, {
          capture: !1,
          passive: !0
        }, {
          capture: !0,
          passive: !1
        }, {
          capture: !0,
          passive: !0
        }].map(function (o) {
          return _this1._getProxyEmitter(i, o);
        }).filter(function (o) {
          return !!o;
        });
      }
    }]);
  }(e);
  return t;
}
["_getProxyEmitter", "_getAllProxyEmitters", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(function (e) {
  D[e] = Vt.prototype[e];
});
var Te = /*#__PURE__*/function (_T) {
  function Te(t, n) {
    var _this10;
    _classCallCheck(this, Te);
    _this10 = _callSuper(this, Te), _defineProperty(_assertThisInitialized(_this10), "_domNode", void 0), _defineProperty(_assertThisInitialized(_this10), "_options", void 0), _defineProperty(_assertThisInitialized(_this10), "_domListeners", void 0), Mt(_assertThisInitialized(_this10), Rt(t, n)), _this10._domNode = t, _this10._options = n;
    return _this10;
  }
  _inherits(Te, _T);
  return _createClass(Te, [{
    key: "attach",
    value: function attach(t) {
      if (this._domListeners && this._domListeners[t]) return;
      var n = this._createDomListener(t);
      this._domNode.addEventListener(t, n, this._options), this._domListeners || (this._domListeners = {}), this._domListeners[t] = n;
    }
  }, {
    key: "detach",
    value: function detach(t) {
      var n;
      this._domListeners[t] && (!(n = this._events[t]) || !n.callbacks.length) && this._domListeners[t].removeListener();
    }
  }, {
    key: "_addEventListener",
    value: function _addEventListener(t, n, i) {
      this.attach(t), T().prototype._addEventListener.call(this, t, n, i);
    }
  }, {
    key: "_removeEventListener",
    value: function _removeEventListener(t, n) {
      T().prototype._removeEventListener.call(this, t, n), this.detach(t);
    }
  }, {
    key: "_createDomListener",
    value: function _createDomListener(t) {
      var _this11 = this;
      var n = function n(i) {
        _this11.fire(t, i);
      };
      return n.removeListener = function () {
        _this11._domNode.removeEventListener(t, n, _this11._options), delete _this11._domListeners[t];
      }, n;
    }
  }]);
}(T());
function xe(e) {
  return e["data-ck-expando"] || (e["data-ck-expando"] = Q());
}
function Rt(e, t) {
  var n = xe(e);
  var _iterator1 = _createForOfIteratorHelper(Object.keys(t).sort()),
    _step1;
  try {
    for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
      var i = _step1.value;
      t[i] && (n += "-" + i);
    }
  } catch (err) {
    _iterator1.e(err);
  } finally {
    _iterator1.f();
  }
  return n;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function yn(e) {
  var t = [];
  var n = e;
  for (; n && n.nodeType != Node.DOCUMENT_NODE;) t.unshift(n), n = n.parentNode;
  return t;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function En(e) {
  return e instanceof HTMLTextAreaElement ? e.value : e.innerHTML;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Pt(e) {
  var t = e.ownerDocument.defaultView.getComputedStyle(e);
  return {
    top: parseInt(t.borderTopWidth, 10),
    right: parseInt(t.borderRightWidth, 10),
    bottom: parseInt(t.borderBottomWidth, 10),
    left: parseInt(t.borderLeftWidth, 10)
  };
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Tn(e) {
  if (!e.target) return null;
  var t = e.target.ownerDocument,
    n = e.clientX,
    i = e.clientY;
  var o = null;
  return t.caretRangeFromPoint && t.caretRangeFromPoint(n, i) ? o = t.caretRangeFromPoint(n, i) : e.rangeParent && (o = t.createRange(), o.setStart(e.rangeParent, e.rangeOffset), o.collapse(!0)), o;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function tt(e) {
  return Object.prototype.toString.call(e) == "[object Text]";
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function et(e) {
  return Object.prototype.toString.apply(e) == "[object Range]";
}
function Nt(e) {
  return !e || !e.parentNode || e.offsetParent === w.document.body ? null : e.offsetParent;
}
var Bt = ["top", "right", "bottom", "left", "width", "height"];
var m = /*#__PURE__*/function () {
  function m(t) {
    _classCallCheck(this, m);
    _defineProperty(this, "top", void 0);
    _defineProperty(this, "right", void 0);
    _defineProperty(this, "bottom", void 0);
    _defineProperty(this, "left", void 0);
    _defineProperty(this, "width", void 0);
    _defineProperty(this, "height", void 0);
    _defineProperty(this, "_source", void 0);
    var n = et(t);
    if (Object.defineProperty(this, "_source", {
      value: t._source || t,
      writable: !0,
      enumerable: !1
    }), J(t) || n) {
      if (n) {
        var i = m.getDomRangeRects(t);
        R(this, m.getBoundingRect(i));
      } else R(this, t.getBoundingClientRect());
    } else if (N(t)) {
      var _i2 = t.innerWidth,
        o = t.innerHeight;
      R(this, {
        top: 0,
        right: _i2,
        bottom: o,
        left: 0,
        width: _i2,
        height: o
      });
    } else R(this, t);
  }
  return _createClass(m, [{
    key: "clone",
    value: function clone() {
      return new m(this);
    }
  }, {
    key: "moveTo",
    value: function moveTo(t, n) {
      return this.top = n, this.right = t + this.width, this.bottom = n + this.height, this.left = t, this;
    }
  }, {
    key: "moveBy",
    value: function moveBy(t, n) {
      return this.top += n, this.right += t, this.left += t, this.bottom += n, this;
    }
  }, {
    key: "getIntersection",
    value: function getIntersection(t) {
      var n = {
        top: Math.max(this.top, t.top),
        right: Math.min(this.right, t.right),
        bottom: Math.min(this.bottom, t.bottom),
        left: Math.max(this.left, t.left),
        width: 0,
        height: 0
      };
      if (n.width = n.right - n.left, n.height = n.bottom - n.top, n.width < 0 || n.height < 0) return null;
      {
        var i = new m(n);
        return i._source = this._source, i;
      }
    }
  }, {
    key: "getIntersectionArea",
    value: function getIntersectionArea(t) {
      var n = this.getIntersection(t);
      return n ? n.getArea() : 0;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      return this.width * this.height;
    }
  }, {
    key: "getVisible",
    value: function getVisible() {
      var t = this._source;
      var n = this.clone();
      if (pt(t)) return n;
      var i = t,
        o = t.parentNode || t.commonAncestorContainer,
        s;
      for (; o && !pt(o);) {
        var r = Ie(o) === "visible";
        i instanceof HTMLElement && gt(i) === "absolute" && (s = i);
        var l = gt(o);
        if (r || s && (l === "relative" && r || l !== "relative")) {
          i = o, o = o.parentNode;
          continue;
        }
        var c = new m(o),
          a = n.getIntersection(c);
        if (a) a.getArea() < n.getArea() && (n = a);else return null;
        i = o, o = o.parentNode;
      }
      return n;
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      for (var _i3 = 0, _Bt = Bt; _i3 < _Bt.length; _i3++) {
        var n = _Bt[_i3];
        if (this[n] !== t[n]) return !1;
      }
      return !0;
    }
  }, {
    key: "contains",
    value: function contains(t) {
      var n = this.getIntersection(t);
      return !!(n && n.isEqual(t));
    }
  }, {
    key: "toAbsoluteRect",
    value: function toAbsoluteRect() {
      var _w$window = w.window,
        t = _w$window.scrollX,
        n = _w$window.scrollY,
        i = this.clone().moveBy(t, n);
      if (J(i._source)) {
        var o = Nt(i._source);
        o && Le(i, o);
      }
      return i;
    }
  }, {
    key: "excludeScrollbarsAndBorders",
    value: function excludeScrollbarsAndBorders() {
      var t = this._source;
      var n, i, o;
      if (N(t)) n = t.innerWidth - t.document.documentElement.clientWidth, i = t.innerHeight - t.document.documentElement.clientHeight, o = t.getComputedStyle(t.document.documentElement).direction;else {
        var s = Pt(t);
        n = t.offsetWidth - t.clientWidth - s.left - s.right, i = t.offsetHeight - t.clientHeight - s.top - s.bottom, o = t.ownerDocument.defaultView.getComputedStyle(t).direction, this.left += s.left, this.top += s.top, this.right -= s.right, this.bottom -= s.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
      }
      return this.width -= n, o === "ltr" ? this.right -= n : this.left += n, this.height -= i, this.bottom -= i, this;
    }
  }], [{
    key: "getDomRangeRects",
    value: function getDomRangeRects(t) {
      var n = [],
        i = Array.from(t.getClientRects());
      if (i.length) {
        var _iterator10 = _createForOfIteratorHelper(i),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var o = _step10.value;
            n.push(new m(o));
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      } else {
        var _o = t.startContainer;
        tt(_o) && (_o = _o.parentNode);
        var s = new m(_o.getBoundingClientRect());
        s.right = s.left, s.width = 0, n.push(s);
      }
      return n;
    }
  }, {
    key: "getBoundingRect",
    value: function getBoundingRect(t) {
      var n = {
        left: Number.POSITIVE_INFINITY,
        top: Number.POSITIVE_INFINITY,
        right: Number.NEGATIVE_INFINITY,
        bottom: Number.NEGATIVE_INFINITY,
        width: 0,
        height: 0
      };
      var i = 0;
      var _iterator11 = _createForOfIteratorHelper(t),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var o = _step11.value;
          i++, n.left = Math.min(n.left, o.left), n.top = Math.min(n.top, o.top), n.right = Math.max(n.right, o.right), n.bottom = Math.max(n.bottom, o.bottom);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      return i == 0 ? null : (n.width = n.right - n.left, n.height = n.bottom - n.top, new m(n));
    }
  }]);
}();
function R(e, t) {
  var _iterator12 = _createForOfIteratorHelper(Bt),
    _step12;
  try {
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var n = _step12.value;
      e[n] = t[n];
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }
}
function pt(e) {
  return J(e) ? e === e.ownerDocument.body : !1;
}
function J(e) {
  return e !== null && _typeof(e) == "object" && e.nodeType === 1 && typeof e.getBoundingClientRect == "function";
}
function gt(e) {
  return e instanceof HTMLElement ? e.ownerDocument.defaultView.getComputedStyle(e).position : "static";
}
function Ie(e) {
  return e instanceof HTMLElement ? e.ownerDocument.defaultView.getComputedStyle(e).overflow : "visible";
}
function Le(e, t) {
  var n = new m(t),
    i = Pt(t);
  var o = 0,
    s = 0;
  o -= n.left, s -= n.top, o += t.scrollLeft, s += t.scrollTop, o -= i.left, s -= i.top, e.moveBy(o, s);
}
var h = /*#__PURE__*/function () {
  function h(t, n) {
    _classCallCheck(this, h);
    _defineProperty(this, "_element", void 0);
    _defineProperty(this, "_callback", void 0);
    h._observerInstance || h._createObserver(), this._element = t, this._callback = n, h._addElementCallback(t, n), h._observerInstance.observe(t);
  }
  return _createClass(h, [{
    key: "element",
    get: function get() {
      return this._element;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      h._deleteElementCallback(this._element, this._callback);
    }
  }], [{
    key: "_addElementCallback",
    value: function _addElementCallback(t, n) {
      h._elementCallbacks || (h._elementCallbacks = new Map());
      var i = h._elementCallbacks.get(t);
      i || (i = new Set(), h._elementCallbacks.set(t, i)), i.add(n);
    }
  }, {
    key: "_deleteElementCallback",
    value: function _deleteElementCallback(t, n) {
      var i = h._getElementCallbacks(t);
      i && (i.delete(n), i.size || (h._elementCallbacks.delete(t), h._observerInstance.unobserve(t))), h._elementCallbacks && !h._elementCallbacks.size && (h._observerInstance = null, h._elementCallbacks = null);
    }
  }, {
    key: "_getElementCallbacks",
    value: function _getElementCallbacks(t) {
      return h._elementCallbacks ? h._elementCallbacks.get(t) : null;
    }
  }, {
    key: "_createObserver",
    value: function _createObserver() {
      h._observerInstance = new w.window.ResizeObserver(function (t) {
        var _iterator13 = _createForOfIteratorHelper(t),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var n = _step13.value;
            var i = h._getElementCallbacks(n.target);
            if (i) {
              var _iterator14 = _createForOfIteratorHelper(i),
                _step14;
              try {
                for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                  var o = _step14.value;
                  o(n);
                }
              } catch (err) {
                _iterator14.e(err);
              } finally {
                _iterator14.f();
              }
            }
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      });
    }
  }]);
}();
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
_defineProperty(h, "_observerInstance", null);
_defineProperty(h, "_elementCallbacks", null);
function xn(e, t) {
  e instanceof HTMLTextAreaElement && (e.value = t), e.innerHTML = t;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function In(e) {
  return function (t) {
    return t + e;
  };
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Ln(e) {
  var t = 0;
  for (; e.previousSibling;) e = e.previousSibling, t++;
  return t;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function An(e, t, n) {
  e.insertBefore(n, e.childNodes[t] || null);
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Cn(e) {
  return e && e.nodeType === Node.COMMENT_NODE;
}
function Fn(e) {
  try {
    w.document.createAttribute(e);
  } catch (_unused3) {
    return !1;
  }
  return !0;
}
function Ae(e) {
  return e ? tt(e) ? Ae(e.parentElement) : e.getClientRects ? !!e.getClientRects().length : !1 : !1;
}
function Mn(_ref6) {
  var e = _ref6.element,
    t = _ref6.target,
    n = _ref6.positions,
    i = _ref6.limiter,
    o = _ref6.fitInViewport,
    s = _ref6.viewportOffsetConfig;
  st(t) && (t = t()), st(i) && (i = i());
  var r = Nt(e),
    l = Ce(s),
    c = new m(e),
    a = mt(t, l);
  var f;
  if (!a || !l.getIntersection(a)) return null;
  var u = {
    targetRect: a,
    elementRect: c,
    positionedElementAncestor: r,
    viewportRect: l
  };
  if (!i && !o) f = new Dt(n[0], u);else {
    if (i) {
      var _ = mt(i, l);
      _ && (u.limiterRect = _);
    }
    f = Fe(n, u);
  }
  return f;
}
function mt(e, t) {
  var n = new m(e).getVisible();
  return n ? n.getIntersection(t) : null;
}
function Ce(e) {
  e = Object.assign({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }, e);
  var t = new m(w.window);
  return t.top += e.top, t.height -= e.top, t.bottom -= e.bottom, t.height -= e.bottom, t;
}
function Fe(e, t) {
  var n = t.elementRect,
    i = n.getArea(),
    o = e.map(function (l) {
      return new Dt(l, t);
    }).filter(function (l) {
      return !!l.name;
    });
  var s = 0,
    r = null;
  var _iterator15 = _createForOfIteratorHelper(o),
    _step15;
  try {
    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
      var l = _step15.value;
      var c = l.limiterIntersectionArea,
        a = l.viewportIntersectionArea;
      if (c === i) return l;
      var f = Math.pow(a, 2) + Math.pow(c, 2);
      f > s && (s = f, r = l);
    }
  } catch (err) {
    _iterator15.e(err);
  } finally {
    _iterator15.f();
  }
  return r;
}
var Dt = /*#__PURE__*/function () {
  function Dt(t, n) {
    _classCallCheck(this, Dt);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "_positioningFunctionCoordinates", void 0);
    _defineProperty(this, "_options", void 0);
    _defineProperty(this, "_cachedRect", void 0);
    _defineProperty(this, "_cachedAbsoluteRect", void 0);
    var i = t(n.targetRect, n.elementRect, n.viewportRect, n.limiterRect);
    if (!i) return;
    var o = i.left,
      s = i.top,
      r = i.name,
      l = i.config;
    this.name = r, this.config = l, this._positioningFunctionCoordinates = {
      left: o,
      top: s
    }, this._options = n;
  }
  return _createClass(Dt, [{
    key: "left",
    get: function get() {
      return this._absoluteRect.left;
    }
  }, {
    key: "top",
    get: function get() {
      return this._absoluteRect.top;
    }
  }, {
    key: "limiterIntersectionArea",
    get: function get() {
      var t = this._options.limiterRect;
      return t ? t.getIntersectionArea(this._rect) : 0;
    }
  }, {
    key: "viewportIntersectionArea",
    get: function get() {
      return this._options.viewportRect.getIntersectionArea(this._rect);
    }
  }, {
    key: "_rect",
    get: function get() {
      return this._cachedRect ? this._cachedRect : (this._cachedRect = this._options.elementRect.clone().moveTo(this._positioningFunctionCoordinates.left, this._positioningFunctionCoordinates.top), this._cachedRect);
    }
  }, {
    key: "_absoluteRect",
    get: function get() {
      return this._cachedAbsoluteRect ? this._cachedAbsoluteRect : (this._cachedAbsoluteRect = this._rect.toAbsoluteRect(), this._cachedAbsoluteRect);
    }
  }]);
}();
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function kn(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
}
function vn() {
  var e = w.window.visualViewport;
  if (!e || !(A.isiOS || A.isSafari)) return {
    left: 0,
    top: 0
  };
  var t = Math.max(Math.round(e.offsetLeft), 0),
    n = Math.max(Math.round(e.offsetTop), 0);
  return {
    left: t,
    top: n
  };
}
function Sn(_ref7) {
  var e = _ref7.target,
    _ref7$viewportOffset = _ref7.viewportOffset,
    t = _ref7$viewportOffset === void 0 ? 0 : _ref7$viewportOffset,
    _ref7$ancestorOffset = _ref7.ancestorOffset,
    n = _ref7$ancestorOffset === void 0 ? 0 : _ref7$ancestorOffset,
    i = _ref7.alignToTop,
    o = _ref7.forceScroll;
  var s = nt(e);
  var r = s,
    l = null;
  for (t = ve(t); r;) {
    var c = void 0;
    r == s ? c = bt(e) : c = bt(l), ke({
      parent: c,
      getRect: function getRect() {
        return U(e, r);
      },
      alignToTop: i,
      ancestorOffset: n,
      forceScroll: o
    });
    var a = U(e, r);
    var f = U(c, r);
    if (a.height > f.height) {
      var u = a.getIntersection(f);
      u && (a = u);
    }
    if (Me({
      window: r,
      rect: a,
      viewportOffset: t,
      alignToTop: i,
      forceScroll: o
    }), r.parent != r) {
      if (l = r.frameElement, r = r.parent, !l) return;
    } else r = null;
  }
}
function Me(_ref8) {
  var e = _ref8.window,
    t = _ref8.rect,
    n = _ref8.alignToTop,
    i = _ref8.forceScroll,
    o = _ref8.viewportOffset;
  var s = t.clone().moveBy(0, o.bottom),
    r = t.clone().moveBy(0, -o.top),
    l = new m(e).excludeScrollbarsAndBorders(),
    c = [r, s],
    a = n && i,
    f = c.every(function (p) {
      return l.contains(p);
    });
  var u = e.scrollX,
    _ = e.scrollY;
  var C = u,
    y = _;
  a ? _ -= l.top - t.top + o.top : f || (Ot(r, l) ? _ -= l.top - t.top + o.top : jt(s, l) && (n ? _ += t.top - l.top - o.top : _ += t.bottom - l.bottom + o.bottom)), f || (Wt(t, l) ? u -= l.left - t.left + o.left : Kt(t, l) && (u += t.right - l.right + o.right)), (u != C || _ !== y) && e.scrollTo(u, _);
}
function ke(_ref9) {
  var e = _ref9.parent,
    t = _ref9.getRect,
    n = _ref9.alignToTop,
    i = _ref9.forceScroll,
    _ref9$ancestorOffset = _ref9.ancestorOffset,
    o = _ref9$ancestorOffset === void 0 ? 0 : _ref9$ancestorOffset,
    s = _ref9.limiterElement;
  var r = nt(e),
    l = n && i;
  var c, a, f;
  var u = s || r.document.body;
  for (; e != u;) a = t(), c = new m(e).excludeScrollbarsAndBorders(), f = c.contains(a), l ? e.scrollTop -= c.top - a.top + o : f || (Ot(a, c) ? e.scrollTop -= c.top - a.top + o : jt(a, c) && (n ? e.scrollTop += a.top - c.top - o : e.scrollTop += a.bottom - c.bottom + o)), f || (Wt(a, c) ? e.scrollLeft -= c.left - a.left + o : Kt(a, c) && (e.scrollLeft += a.right - c.right + o)), e = e.parentNode;
}
function jt(e, t) {
  return e.bottom > t.bottom;
}
function Ot(e, t) {
  return e.top < t.top;
}
function Wt(e, t) {
  return e.left < t.left;
}
function Kt(e, t) {
  return e.right > t.right;
}
function nt(e) {
  return et(e) ? e.startContainer.ownerDocument.defaultView : e.ownerDocument.defaultView;
}
function bt(e) {
  if (et(e)) {
    var t = e.commonAncestorContainer;
    return tt(t) && (t = t.parentNode), t;
  } else return e.parentNode;
}
function U(e, t) {
  var n = nt(e),
    i = new m(e);
  if (n === t) return i;
  {
    var o = n;
    for (; o != t;) {
      var s = o.frameElement,
        r = new m(s).excludeScrollbarsAndBorders();
      i.moveBy(r.left, r.top), o = o.parent;
    }
  }
  return i;
}
function ve(e) {
  return typeof e == "number" ? {
    top: e,
    bottom: e,
    left: e,
    right: e
  } : e;
}
var Se = {
    ctrl: "⌃",
    cmd: "⌘",
    alt: "⌥",
    shift: "⇧"
  },
  Ve = {
    ctrl: "Ctrl+",
    alt: "Alt+",
    shift: "Shift+"
  },
  _t = {
    37: "←",
    38: "↑",
    39: "→",
    40: "↓",
    9: "⇥",
    33: "Page Up",
    34: "Page Down"
  },
  g = Be(),
  Re = Object.fromEntries(Object.entries(g).map(function (_ref0) {
    var _ref1 = _slicedToArray(_ref0, 2),
      e = _ref1[0],
      t = _ref1[1];
    var n;
    return t in _t ? n = _t[t] : n = e.charAt(0).toUpperCase() + e.slice(1), [t, n];
  }));
function B(e) {
  var t;
  if (typeof e == "string") {
    if (t = g[e.toLowerCase()], !t) throw new d("keyboard-unknown-key", null, {
      key: e
    });
  } else t = e.keyCode + (e.altKey ? g.alt : 0) + (e.ctrlKey ? g.ctrl : 0) + (e.shiftKey ? g.shift : 0) + (e.metaKey ? g.cmd : 0);
  return t;
}
function Ht(e) {
  return typeof e == "string" && (e = De(e)), e.map(function (t) {
    return typeof t == "string" ? Ne(t) : t;
  }).reduce(function (t, n) {
    return n + t;
  }, 0);
}
function Vn(e, t) {
  var n = Ht(e);
  var i = A.isMac || A.isiOS;
  return Object.entries(i ? Se : Ve).reduce(function (r, _ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      l = _ref11[0],
      c = _ref11[1];
    return (n & g[l]) != 0 && (n &= ~g[l], r += c), r;
  }, "") + (n ? Re[n] : "");
}
function Rn(e) {
  return e == g.arrowright || e == g.arrowleft || e == g.arrowup || e == g.arrowdown;
}
function Pe(e, t) {
  var n = t === "ltr";
  switch (e) {
    case g.arrowleft:
      return n ? "left" : "right";
    case g.arrowright:
      return n ? "right" : "left";
    case g.arrowup:
      return "up";
    case g.arrowdown:
      return "down";
  }
}
function Ne(e) {
  if (e.endsWith("!")) return B(e.slice(0, -1));
  var t = B(e);
  return (A.isMac || A.isiOS) && t == g.ctrl ? g.cmd : t;
}
function Pn(e, t) {
  var n = Pe(e, t);
  return n === "down" || n === "right";
}
function Be() {
  var e = {
    pageup: 33,
    pagedown: 34,
    end: 35,
    home: 36,
    arrowleft: 37,
    arrowup: 38,
    arrowright: 39,
    arrowdown: 40,
    backspace: 8,
    delete: 46,
    enter: 13,
    space: 32,
    esc: 27,
    tab: 9,
    ctrl: 1114112,
    shift: 2228224,
    alt: 4456448,
    cmd: 8912896
  };
  for (var t = 65; t <= 90; t++) {
    var n = String.fromCharCode(t);
    e[n.toLowerCase()] = t;
  }
  for (var _t3 = 48; _t3 <= 57; _t3++) e[_t3 - 48] = _t3;
  for (var _t4 = 112; _t4 <= 123; _t4++) e["f" + (_t4 - 111)] = _t4;
  return Object.assign(e, {
    "'": 222,
    ",": 108,
    "-": 109,
    ".": 110,
    "/": 111,
    ";": 186,
    "=": 187,
    "[": 219,
    "\\": 220,
    "]": 221,
    "`": 223
  }), e;
}
function De(e) {
  return e.split("+").map(function (t) {
    return t.trim();
  });
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
var je = ["ar", "ara", "dv", "div", "fa", "per", "fas", "he", "heb", "ku", "kur", "ug", "uig", "ur", "urd"];
function wt(e) {
  return je.includes(e) ? "rtl" : "ltr";
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Oe(e) {
  return Array.isArray(e) ? e : [e];
} /* istanbul ignore else -- @preserve */
w.window.CKEDITOR_TRANSLATIONS || (w.window.CKEDITOR_TRANSLATIONS = {});
function We(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var i = arguments.length > 3 ? arguments[3] : undefined;
  if (typeof n != "number") throw new d("translation-service-quantity-not-a-number", null, {
    quantity: n
  });
  var o = i || w.window.CKEDITOR_TRANSLATIONS,
    s = Ue(o);
  s === 1 && (e = Object.keys(o)[0]);
  var r = t.id || t.string;
  if (s === 0 || !He(e, r, o)) return n !== 1 ? t.plural : t.string;
  var l = o[e].dictionary,
    c = o[e].getPluralForm || function (u) {
      return u === 1 ? 0 : 1;
    },
    a = l[r];
  if (typeof a == "string") return a;
  var f = Number(c(n));
  return a[f];
}
function Ke(e) {
  return Array.isArray(e) ? e.reduce(function (t, n) {
    return Gt(t, n);
  }) : e;
}
function He(e, t, n) {
  return !!n[e] && !!n[e].dictionary[t];
}
function Ue(e) {
  return Object.keys(e).length;
}
var Nn = /*#__PURE__*/function () {
  function Nn() {
    var _this12 = this;
    var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref12$uiLanguage = _ref12.uiLanguage,
      t = _ref12$uiLanguage === void 0 ? "en" : _ref12$uiLanguage,
      n = _ref12.contentLanguage,
      i = _ref12.translations;
    _classCallCheck(this, Nn);
    _defineProperty(this, "uiLanguage", void 0);
    _defineProperty(this, "uiLanguageDirection", void 0);
    _defineProperty(this, "contentLanguage", void 0);
    _defineProperty(this, "contentLanguageDirection", void 0);
    _defineProperty(this, "t", void 0);
    _defineProperty(this, "translations", void 0);
    this.uiLanguage = t, this.contentLanguage = n || this.uiLanguage, this.uiLanguageDirection = wt(this.uiLanguage), this.contentLanguageDirection = wt(this.contentLanguage), this.translations = Ke(i), this.t = function (o, s) {
      return _this12._t(o, s);
    };
  }
  return _createClass(Nn, [{
    key: "language",
    get: function get() {
      return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
    }
  }, {
    key: "_t",
    value: function _t(t) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      n = Oe(n), typeof t == "string" && (t = {
        string: t
      });
      var o = !!t.plural ? n[0] : 1,
        s = We(this.uiLanguage, t, o, this.translations);
      return $e(s, n);
    }
  }]);
}();
function $e(e, t) {
  return e.replace(/%(\d+)/g, function (n, i) {
    return i < t.length ? t[i] : n;
  });
}
var Bn = /*#__PURE__*/function (_T2) {
  function Bn() {
    var _this13;
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Bn);
    _this13 = _callSuper(this, Bn);
    _defineProperty(_this13, "_items", void 0);
    _defineProperty(_this13, "_itemMap", void 0);
    _defineProperty(_this13, "_idProperty", void 0);
    _defineProperty(_this13, "_bindToCollection", void 0);
    _defineProperty(_this13, "_bindToExternalToInternalMap", void 0);
    _defineProperty(_this13, "_bindToInternalToExternalMap", void 0);
    _defineProperty(_this13, "_skippedIndexesFromExternal", void 0);
    var i = z(t);
    if (i || (n = t), _this13._items = [], _this13._itemMap = new Map(), _this13._idProperty = n.idProperty || "id", _this13._bindToExternalToInternalMap = new WeakMap(), _this13._bindToInternalToExternalMap = new WeakMap(), _this13._skippedIndexesFromExternal = [], i) {
      var _iterator16 = _createForOfIteratorHelper(t),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var o = _step16.value;
          _this13._items.push(o), _this13._itemMap.set(_this13._getItemIdBeforeAdding(o), o);
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
    }
    return _this13;
  }
  _inherits(Bn, _T2);
  return _createClass(Bn, [{
    key: "length",
    get: function get() {
      return this._items.length;
    }
  }, {
    key: "first",
    get: function get() {
      return this._items[0] || null;
    }
  }, {
    key: "last",
    get: function get() {
      return this._items[this.length - 1] || null;
    }
  }, {
    key: "add",
    value: function add(t, n) {
      return this.addMany([t], n);
    }
  }, {
    key: "addMany",
    value: function addMany(t, n) {
      if (n === void 0) n = this._items.length;else if (n > this._items.length || n < 0) throw new d("collection-add-item-invalid-index", this);
      var i = 0;
      var _iterator17 = _createForOfIteratorHelper(t),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var o = _step17.value;
          var s = this._getItemIdBeforeAdding(o),
            r = n + i;
          this._items.splice(r, 0, o), this._itemMap.set(s, o), this.fire("add", o, r), i++;
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
      return this.fire("change", {
        added: t,
        removed: [],
        index: n
      }), this;
    }
  }, {
    key: "get",
    value: function get(t) {
      var n;
      if (typeof t == "string") n = this._itemMap.get(t);else if (typeof t == "number") n = this._items[t];else throw new d("collection-get-invalid-arg", this);
      return n || null;
    }
  }, {
    key: "has",
    value: function has(t) {
      if (typeof t == "string") return this._itemMap.has(t);
      {
        var n = this._idProperty,
          i = t[n];
        return i && this._itemMap.has(i);
      }
    }
  }, {
    key: "getIndex",
    value: function getIndex(t) {
      var n;
      return typeof t == "string" ? n = this._itemMap.get(t) : n = t, n ? this._items.indexOf(n) : -1;
    }
  }, {
    key: "remove",
    value: function remove(t) {
      var _this$_remove = this._remove(t),
        _this$_remove2 = _slicedToArray(_this$_remove, 2),
        n = _this$_remove2[0],
        i = _this$_remove2[1];
      return this.fire("change", {
        added: [],
        removed: [n],
        index: i
      }), n;
    }
  }, {
    key: "map",
    value: function map(t, n) {
      return this._items.map(t, n);
    }
  }, {
    key: "forEach",
    value: function forEach(t, n) {
      this._items.forEach(t, n);
    }
  }, {
    key: "find",
    value: function find(t, n) {
      return this._items.find(t, n);
    }
  }, {
    key: "filter",
    value: function filter(t, n) {
      return this._items.filter(t, n);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null);
      var t = Array.from(this._items);
      for (; this.length;) this._remove(0);
      this.fire("change", {
        added: [],
        removed: t,
        index: 0
      });
    }
  }, {
    key: "bindTo",
    value: function bindTo(t) {
      var _this14 = this;
      if (this._bindToCollection) throw new d("collection-bind-to-rebind", this);
      return this._bindToCollection = t, {
        as: function as(n) {
          _this14._setUpBindToBinding(function (i) {
            return new n(i);
          });
        },
        using: function using(n) {
          typeof n == "function" ? _this14._setUpBindToBinding(n) : _this14._setUpBindToBinding(function (i) {
            return i[n];
          });
        }
      };
    }
  }, {
    key: "_setUpBindToBinding",
    value: function _setUpBindToBinding(t) {
      var _this15 = this;
      var n = this._bindToCollection,
        i = function i(o, s, r) {
          var l = n._bindToCollection == _this15,
            c = n._bindToInternalToExternalMap.get(s);
          if (l && c) _this15._bindToExternalToInternalMap.set(s, c), _this15._bindToInternalToExternalMap.set(c, s);else {
            var a = t(s);
            if (!a) {
              _this15._skippedIndexesFromExternal.push(r);
              return;
            }
            var f = r;
            var _iterator18 = _createForOfIteratorHelper(_this15._skippedIndexesFromExternal),
              _step18;
            try {
              for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                var _u = _step18.value;
                r > _u && f--;
              }
            } catch (err) {
              _iterator18.e(err);
            } finally {
              _iterator18.f();
            }
            var _iterator19 = _createForOfIteratorHelper(n._skippedIndexesFromExternal),
              _step19;
            try {
              for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                var _u2 = _step19.value;
                f >= _u2 && f++;
              }
            } catch (err) {
              _iterator19.e(err);
            } finally {
              _iterator19.f();
            }
            _this15._bindToExternalToInternalMap.set(s, a), _this15._bindToInternalToExternalMap.set(a, s), _this15.add(a, f);
            for (var u = 0; u < n._skippedIndexesFromExternal.length; u++) f <= n._skippedIndexesFromExternal[u] && n._skippedIndexesFromExternal[u]++;
          }
        };
      var _iterator20 = _createForOfIteratorHelper(n),
        _step20;
      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var o = _step20.value;
          i(null, o, n.getIndex(o));
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
      this.listenTo(n, "add", i), this.listenTo(n, "remove", function (o, s, r) {
        var l = _this15._bindToExternalToInternalMap.get(s);
        l && _this15.remove(l), _this15._skippedIndexesFromExternal = _this15._skippedIndexesFromExternal.reduce(function (c, a) {
          return r < a && c.push(a - 1), r > a && c.push(a), c;
        }, []);
      });
    }
  }, {
    key: "_getItemIdBeforeAdding",
    value: function _getItemIdBeforeAdding(t) {
      var n = this._idProperty;
      var i;
      if (n in t) {
        if (i = t[n], typeof i != "string") throw new d("collection-add-invalid-id", this);
        if (this.get(i)) throw new d("collection-add-item-already-exists", this);
      } else t[n] = i = Q();
      return i;
    }
  }, {
    key: "_remove",
    value: function _remove(t) {
      var n,
        i,
        o,
        s = !1;
      var r = this._idProperty;
      if (typeof t == "string" ? (i = t, o = this._itemMap.get(i), s = !o, o && (n = this._items.indexOf(o))) : typeof t == "number" ? (n = t, o = this._items[n], s = !o, o && (i = o[r])) : (o = t, i = o[r], n = this._items.indexOf(o), s = n == -1 || !this._itemMap.get(i)), s) throw new d("collection-remove-404", this);
      this._items.splice(n, 1), this._itemMap.delete(i);
      var l = this._bindToInternalToExternalMap.get(o);
      return this._bindToInternalToExternalMap.delete(o), this._bindToExternalToInternalMap.delete(l), this.fire("remove", o, n), [o, n];
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this._items[Symbol.iterator]();
    }
  }]);
}(T());
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function Dn(e) {
  var t = e.next();
  return t.done ? null : t.value;
}
var Ge = /*#__PURE__*/function (_D) {
  function Ge() {
    var _this16;
    _classCallCheck(this, Ge);
    _this16 = _callSuper(this, Ge), _defineProperty(_assertThisInitialized(_this16), "_elements", new Set()), _defineProperty(_assertThisInitialized(_this16), "_externalViews", new Set()), _defineProperty(_assertThisInitialized(_this16), "_blurTimeout", null), _this16.set("isFocused", !1), _this16.set("focusedElement", null);
    return _this16;
  }
  _inherits(Ge, _D);
  return _createClass(Ge, [{
    key: "elements",
    get: function get() {
      return Array.from(this._elements.values());
    }
  }, {
    key: "externalViews",
    get: function get() {
      return Array.from(this._externalViews.values());
    }
  }, {
    key: "add",
    value: function add(t) {
      if (Et(t)) this._addElement(t);else if (yt(t)) this._addView(t);else {
        if (!t.element) throw new d("focustracker-add-view-missing-element", {
          focusTracker: this,
          view: t
        });
        this._addElement(t.element);
      }
    }
  }, {
    key: "remove",
    value: function remove(t) {
      Et(t) ? this._removeElement(t) : yt(t) ? this._removeView(t) : this._removeElement(t.element);
    }
  }, {
    key: "_addElement",
    value: function _addElement(t) {
      var _this17 = this;
      if (this._elements.has(t)) throw new d("focustracker-add-element-already-exist", this);
      this.listenTo(t, "focus", function () {
        var n = _this17.externalViews.find(function (i) {
          return qe(t, i);
        });
        n ? _this17._focus(n.element) : _this17._focus(t);
      }, {
        useCapture: !0
      }), this.listenTo(t, "blur", function () {
        _this17._blur();
      }, {
        useCapture: !0
      }), this._elements.add(t);
    }
  }, {
    key: "_removeElement",
    value: function _removeElement(t) {
      this._elements.has(t) && (this.stopListening(t), this._elements.delete(t)), t === this.focusedElement && this._blur();
    }
  }, {
    key: "_addView",
    value: function _addView(t) {
      var _this18 = this;
      t.element && this._addElement(t.element), this.listenTo(t.focusTracker, "change:focusedElement", function () {
        t.focusTracker.focusedElement ? t.element && _this18._focus(t.element) : _this18._blur();
      }), this._externalViews.add(t);
    }
  }, {
    key: "_removeView",
    value: function _removeView(t) {
      t.element && this._removeElement(t.element), this.stopListening(t.focusTracker), this._externalViews.delete(t);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening(), this._elements.clear(), this._externalViews.clear(), this.isFocused = !1, this.focusedElement = null;
    }
  }, {
    key: "_focus",
    value: function _focus(t) {
      this._clearBlurTimeout(), this.focusedElement = t, this.isFocused = !0;
    }
  }, {
    key: "_blur",
    value: function _blur() {
      var _this19 = this;
      this.elements.find(function (i) {
        return i.contains(document.activeElement);
      }) || this.externalViews.find(function (i) {
        return i.focusTracker.isFocused && !i.focusTracker._blurTimeout;
      }) || (this._clearBlurTimeout(), this._blurTimeout = setTimeout(function () {
        _this19.focusedElement = null, _this19.isFocused = !1;
      }, 0));
    }
  }, {
    key: "_clearBlurTimeout",
    value: function _clearBlurTimeout() {
      clearTimeout(this._blurTimeout), this._blurTimeout = null;
    }
  }]);
}(D(Z()));
function yt(e) {
  return "focusTracker" in e && e.focusTracker instanceof Ge;
}
function Et(e) {
  return xt(e);
}
function qe(e, t) {
  return Tt(e, t) ? !0 : !!t.focusTracker.externalViews.find(function (n) {
    return Tt(e, n);
  });
}
function Tt(e, t) {
  return !!t.element && t.element.contains(document.activeElement) && e.contains(t.element);
}
var jn = /*#__PURE__*/function () {
  function jn() {
    _classCallCheck(this, jn);
    _defineProperty(this, "_listener", void 0);
    this._listener = new (D())();
  }
  return _createClass(jn, [{
    key: "listenTo",
    value: function listenTo(t) {
      var _this20 = this;
      this._listener.listenTo(t, "keydown", function (n, i) {
        _this20._listener.fire("_keydown:" + B(i), i);
      });
    }
  }, {
    key: "set",
    value: function set(t, n) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var o = Ht(t),
        s = i.priority;
      this._listener.listenTo(this._listener, "_keydown:" + o, function (r, l) {
        i.filter && !i.filter(l) || (n(l, function () {
          l.preventDefault(), l.stopPropagation(), r.stop();
        }), r.return = !0);
      }, {
        priority: s
      });
    }
  }, {
    key: "press",
    value: function press(t) {
      return !!this._listener.fire("_keydown:" + B(t), t);
    }
  }, {
    key: "stopListening",
    value: function stopListening(t) {
      this._listener.stopListening(t);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening();
    }
  }]);
}();
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function Ye(e) {
  var t = new Map();
  for (var n in e) t.set(n, e[n]);
  return t;
}
function On(e) {
  return z(e) ? new Map(e) : Ye(e);
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Wn(e, t, n) {
  var i = e.length,
    o = t.length;
  for (var s = i - 1; s >= n; s--) e[s + o] = e[s];
  for (var _s = 0; _s < o; _s++) e[n + _s] = t[_s];
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Kn(e, t) {
  var n;
  function i() {
    for (var _len9 = arguments.length, o = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      o[_key9] = arguments[_key9];
    }
    i.cancel(), n = setTimeout(function () {
      return e.apply(void 0, o);
    }, t);
  }
  return i.cancel = function () {
    clearTimeout(n);
  }, i;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Hn(e) {
  try {
    if (!e.startsWith("ey")) return null;
    var t = atob(e.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(t);
  } catch (_unused4) {
    return null;
  }
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Xe() {
  var e = [];
  for (var t = 0; t < 256; t++) {
    var n = t;
    for (var i = 0; i < 8; i++) n & 1 ? n = 3988292384 ^ n >>> 1 : n = n >>> 1;
    e[t] = n;
  }
  return e;
}
function Un(e) {
  var t = Array.isArray(e) ? e : [e],
    n = Xe();
  var i = -1;
  var o = t.map(function (s) {
    return Array.isArray(s) ? s.join("") : String(s);
  }).join("");
  for (var s = 0; s < o.length; s++) {
    var r = o.charCodeAt(s);
    i = i >>> 8 ^ n[(i ^ r) & 255];
  }
  return i = (i ^ -1) >>> 0, i.toString(16).padStart(8, "0");
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function $n(e) {
  var t = [{
      name: "address",
      isVoid: !1
    }, {
      name: "article",
      isVoid: !1
    }, {
      name: "aside",
      isVoid: !1
    }, {
      name: "blockquote",
      isVoid: !1
    }, {
      name: "details",
      isVoid: !1
    }, {
      name: "dialog",
      isVoid: !1
    }, {
      name: "dd",
      isVoid: !1
    }, {
      name: "div",
      isVoid: !1
    }, {
      name: "dl",
      isVoid: !1
    }, {
      name: "dt",
      isVoid: !1
    }, {
      name: "fieldset",
      isVoid: !1
    }, {
      name: "figcaption",
      isVoid: !1
    }, {
      name: "figure",
      isVoid: !1
    }, {
      name: "footer",
      isVoid: !1
    }, {
      name: "form",
      isVoid: !1
    }, {
      name: "h1",
      isVoid: !1
    }, {
      name: "h2",
      isVoid: !1
    }, {
      name: "h3",
      isVoid: !1
    }, {
      name: "h4",
      isVoid: !1
    }, {
      name: "h5",
      isVoid: !1
    }, {
      name: "h6",
      isVoid: !1
    }, {
      name: "header",
      isVoid: !1
    }, {
      name: "hgroup",
      isVoid: !1
    }, {
      name: "hr",
      isVoid: !0
    }, {
      name: "li",
      isVoid: !1
    }, {
      name: "main",
      isVoid: !1
    }, {
      name: "nav",
      isVoid: !1
    }, {
      name: "ol",
      isVoid: !1
    }, {
      name: "p",
      isVoid: !1
    }, {
      name: "section",
      isVoid: !1
    }, {
      name: "table",
      isVoid: !1
    }, {
      name: "tbody",
      isVoid: !1
    }, {
      name: "td",
      isVoid: !1
    }, {
      name: "th",
      isVoid: !1
    }, {
      name: "thead",
      isVoid: !1
    }, {
      name: "tr",
      isVoid: !1
    }, {
      name: "ul",
      isVoid: !1
    }],
    n = t.map(function (r) {
      return r.name;
    }).join("|"),
    i = e.replace(new RegExp("</?(".concat(n, ")( .*?)?>"), "g"), "\n$&\n").replace(/<br[^>]*>/g, "$&\n").split("\n");
  var o = 0,
    s = !1;
  return i.map(function (r) {
    return s = Ze(r, s), !r.length && !s ? "" : Je(r, t) ? P(r, o++) : Qe(r, t) ? P(r, --o) : s === "middle" || s === "last" ? P(r, 0) : P(r, o);
  }).join("").trimEnd();
}
function Je(e, t) {
  return t.some(function (n) {
    return !(n.isVoid || !new RegExp("<".concat(n.name, "( .*?)?>")).test(e));
  });
}
function Qe(e, t) {
  return t.some(function (n) {
    return new RegExp("</".concat(n.name, ">")).test(e);
  });
}
function P(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "    ";
  return "".concat(n.repeat(Math.max(0, t))).concat(e, "\n");
}
function Ze(e, t) {
  var n = /<pre( .*?)?>/.test(e),
    i = /<\/pre>/.test(e);
  return n && i ? !1 : n ? "first" : i ? "last" : t === "first" || t === "middle" ? "middle" : !1;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function ze(e) {
  return !!e && e.length == 1 && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(e);
}
function tn(e) {
  return !!e && e.length == 1 && /[\ud800-\udbff]/.test(e);
}
function en(e) {
  return !!e && e.length == 1 && /[\udc00-\udfff]/.test(e);
}
function Gn(e, t) {
  return tn(e.charAt(t - 1)) && en(e.charAt(t));
}
function qn(e, t) {
  return ze(e.charAt(t));
}
var nn = on();
function Yn(e, t) {
  var n = String(e).matchAll(nn);
  return Array.from(n).some(function (i) {
    return i.index < t && t < i.index + i[0].length;
  });
}
function on() {
  var e = [new RegExp("\\p{Emoji}[\\u{E0020}-\\u{E007E}]+\\u{E007F}", "u"), new RegExp("\\p{Emoji}\\u{FE0F}?\\u{20E3}", "u"), new RegExp("\\p{Emoji}\\u{FE0F}", "u"), new RegExp("(?=\\p{General_Category=Other_Symbol})\\p{Emoji}\\p{Emoji_Modifier}*", "u")],
    t = new RegExp("\\p{Regional_Indicator}{2}", "u").source,
    n = "(?:" + e.map(function (o) {
      return o.source;
    }).join("|") + ")",
    i = "".concat(t, "|").concat(n, "(?:\u200D").concat(n, ")*");
  return new RegExp(i, "ug");
}
export { d as CKEditorError, Bn as Collection, wn as Config, D as DomEmitterMixin, gn as ElementReplacer, T as EmitterMixin, G as EventInfo, Ge as FocusTracker, jn as KeystrokeHandler, Nn as Locale, Z as ObservableMixin, m as Rect, h as ResizeObserver, bn as compareArrays, mn as count, Un as crc32, _n as createElement, Kn as delay, Lt as diff, A as env, ee as fastDiff, Dn as first, $n as formatHtml, yn as getAncestors, Pt as getBorderWidths, B as getCode, En as getDataFromElement, Vn as getEnvKeystrokeText, wt as getLanguageDirection, Pe as getLocalizedArrowKeyCodeDirection, Mn as getOptimalPosition, Tn as getRangeFromMouseEvent, vn as getVisualViewportOffset, w as global, Ln as indexOf, An as insertAt, se as insertToPriorityArray, Rn as isArrowKeyCode, ze as isCombiningMark, Cn as isComment, Pn as isForwardArrowKeyCode, tn as isHighSurrogateHalf, qn as isInsideCombinedSymbol, Yn as isInsideEmojiSequence, Gn as isInsideSurrogatePair, z as isIterable, en as isLowSurrogateHalf, ht as isNode, et as isRange, tt as isText, Fn as isValidAttributeName, yt as isViewWithFocusTracker, Ae as isVisible, g as keyCodes, hn as logError, dn as logWarning, Hn as parseBase64EncodedObject, Ht as parseKeystroke, q as priorities, pn as releaseDate, kn as remove, Sn as scrollViewportToShowTarget, xn as setDataInElement, Wn as spliceArray, Oe as toArray, On as toMap, In as toUnit, Q as uid, ce as version };